module.exports = __webpack_public_path__ + "img/16.f4d9794c.png";